import { dateFormat, rupiahFormat } from "../utils/format";
import { Fragment } from "react";

const titles = ["Produk", "Jumlah Pembayaran", "Nomor Hewan", "Rencana Pemotongan"];

export const EventTrackingMatched = ({ trackingDetails, cuttingPlanEvents }) => {
    const reformData = trackingDetails?.map((detail, index) => {
      const event = cuttingPlanEvents?.find(event => event.meta.order_detail_id == detail.id); // eslint-disable-line eqeqeq
      
      return {
        program: detail.program,
        amount: detail.amount,
        neats_number: event?.meta?.neats_number ?? null,
        cutting_plan_at: event?.meta?.cutting_plan_at ?? null,
      }
    });

    return (
        <div className="grid grid-cols-4 mt-0 sm:mt-8 font-Rubik text-base sm:text-[15px] font-semibold text-[#787878]">
          {titles.map((title, index) => (
            <div key={index} className="bg-[#F5F5F5] py-1 font-light text-center">
              <h3>{title}</h3>
            </div>
          ))}
          {
            reformData?.map((item, index) => (
              <Fragment key={index}>
                <div className="col-span-1 text-center">
                  <h4 key={index + 1} className="my-4 max-w-[400px] mx-auto ">
                    {item.program}
                  </h4>
                </div>
                <div className=" text-center">
                  <h3 key={index + 1} className="my-4 max-w-[200px] mx-auto ">
                    {rupiahFormat(item.amount)}
                  </h3>
                </div>
                <div className=" text-center">
                  <h3 className="my-4 max-w-[200px] mx-auto ">
                    {item.neats_number ?? "-"}
                  </h3>
                </div>
                <div className=" text-center">
                  <h1 className="my-4 max-w-[200px] text-[#82BE41] mx-auto">
                    {dateFormat(item.cutting_plan_at)}
                  </h1>
                </div>                
              </Fragment>
            ))
          }
      </div>
    );
}